"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.inputRefCreator = inputRefCreator;
var _utils = require("../../utils");
var _actions = require("../../actions");
function inputRefCreator(getState, dispatch, reconcile, eventHandler) {
  const {
    formElement,
    inputStates
  } = getState();
  return (inputElement, rules) => {
    if (inputElement) {
      if (!inputElement.form) {
        _utils.LOGGER.error('The following element has no parent form element:', inputElement);
        return;
      }
      if (formElement && formElement !== inputElement.form) {
        _utils.LOGGER.error(`The following element's parent form is different than the previously registered form:`, inputElement);
        return;
      }
      if (!inputElement.name) {
        _utils.LOGGER.error('The following element has no name attribute (which complicates things):', inputElement);
        return;
      }
      if (!formElement) {
        dispatch((0, _actions.formMount)(inputElement.form, eventHandler));
      }
      if (!inputStates.has(inputElement)) {
        dispatch((0, _actions.createInputState)(inputElement, rules));
      }
      return;
    }
    reconcile(); // need to let React update the DOM first, but only once per render
  };
}